<template>
  <div class='ListItem' :class="{ gray: !isPar(chave) }">
    <div class="cont-check" :style="{ width: checkbox ? '3%' : '1%' }">
      <input :checked="check" type="checkbox"
      @change="e => check ? ListItemSelectedDel([data]) : ListItemSelectedPush([data])"
      v-if="checkbox"
      >
    </div>
    <div
    v-for="(h, key) in headers"
    :key="key"
    :style="{ width: h.width }"
    class="data"
    >
      {{ data[h.chave] }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'ListItem',
  props: {
    headers: {
      type: Array,
      default: () => ([ { chave: 'text', width: '10%' } ])
    },
    data: {
      type: Object,
      default: () => ({ text: 'some_text' })
    },
    chave: {
      type: Number,
      default: 0
    },
    checkbox: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['listItemSelected']),
    check () {
      return this.listItemSelected.map(i => i.id).indexOf(this.data.id) >= 0
    }
  },
  methods: {
    ...mapActions(['ListItemSelectedPush', 'ListItemSelectedDel']),
    isPar (n) {
      let d = n / 2
      return d % 1 === 0
    }
  }
}
</script>

<style scoped>
.ListItem {
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: left;
}
.cont-check {
  width: 2%;
}
.data {
  text-align: left;
  font-size: 14px;
}
.gray {
  background-color: #F5F5F5F5;
}
</style>
